import { gql } from "@apollo/client";

export const CREATE_CUSTOMER = gql`
  mutation CreateCustomerMutation($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomerMutation($id: Int!, $input: UpdateCustomerInput!) {
    updateCustomer(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_CUSTOMER = gql`
  mutation RemoveCustomerMutation($id: Int!) {
    removeCustomer(id: $id) {
      ok
      error
    }
  }
`;

export const CUSTOMER = gql`
  query CustomerQuery($id: Int!) {
    customer(id: $id) {
      ok
      error
      result {
        id
        name
        priceOnly
        email
        siren
        phone
        categoryId
        isComplete
        category {
          id
          name
        }
      }
    }
  }
`;

export const CUSTOMERS = gql`
  query CustomersQuery($where: CustomersFiltersInput!) {
    customers(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        name
        priceOnly
        email
        siren
        phone
        isComplete
      }
    }
  }
`;
